<template>
  <div>
    <sFormItem
      :label="hideLabel ? '' : $t('OrgSettings.settingValue')"
      :prop="prop"
      :show-message="showMessage">
      <div class="flex flex-between">
        <transition-group
          class="width-100"
          :class="{'pr-2': $slots.default}"
          name="s-zoom-in-center"
          tag="div">
          <sInput
            v-if="loading"
            key="load-item"
            readonly/>
          <SettingsList
            v-else-if="setting.settingType === settingTypes.inputList || setting.settingType === settingTypes.emailList"
            key="list-item"
            :value.sync="settingValue"/>
          <!-- Ждем новый тип formList и тогда только для него включаем multi-->
          <SettingsFormio
            v-else-if="settingValue && (setting.settingType === settingTypes.form/* || setting.settingType === settingTypes.formList*/)"
            key="formios-item"
            :form="form"
            :value.sync="settingValue"/>
          <sSelect
            v-else-if="setting.settingType === settingTypes.multipleSelectList || setting.settingType === settingTypes.singleSelectList"
            key="select-item"
            class="width-100"
            filterable
            :multiple="setting.settingType === settingTypes.multipleSelectList"
            :value.sync="settingValue">
            <sOption
              v-for="([k, v]) in Object.entries(setting.availableValues || [])"
              :key="`select-item-option-${k}`"
              :label="v"
              :value="k"/>
          </sSelect>
          <SettingHtmlView
            v-else-if="setting.settingType === settingTypes.html"
            key="html-item"
            style="max-height: 300px; overflow: auto;"
            :value="settingValue"/>
          <template
            v-else>
            <component
              :is="componentType"
              key="other-item"
              v-bind="options"
              :value.sync="settingValue"/>
            <sAlert
              v-if="settingValue && settingType === settingTypes.boolean && !['+', '-'].includes(settingValue)"
              class="mt-2"
              show-icon
              small
              type="error">
              {{ $t('OrgSettings.Errors.SettingValue') }}
              <template slot="desc">
                <div><i>{{ $t('OrgSettings.Errors.Value') }}</i> {{ settingValue }}</div>
                <div><i>{{ $t('OrgSettings.NeedValue') }}</i> <b>+</b> <b>-</b></div>
              </template>
            </sAlert>
          </template>
        </transition-group>
        <div class="my-auto">
          <slot/>
        </div>
      </div>
    </sFormItem>
    <sAlert
      v-if="errorMessage"
      show-icon
      small
      type="error">
      {{ errorMessage }}
    </sAlert>
  </div>
</template>
<script>
import TimeSpan from 'components/common/TimeSpan.vue'
import organizerSettings from 'mixins/organizerSettings'
import SettingsList from 'components/organizer-settings/SettingsList.vue'
import SettingsFormio from 'components/organizer-settings/SettingFormio.vue'
import SettingHtmlView from 'components/organizer-settings/SettingHtmlView.vue'


export default {
  name: 'settingItem',
  mixins: [organizerSettings],
  computed: {
    errorMessage() {
      if (this.setting.settingType === this.settingTypes.multipleSelectList && this.settingValue) {
        const notContainKey = this.settingValue.filter(i => !Object.keys(this.setting.availableValues || {}).includes(i))
        return notContainKey?.length ? `${this.$t('OrgSettings.ExistsNotKnowKey')} ("${notContainKey.join(', ')}")` : ''
      }
      return null
    },
    options() {
      if (this.settingType === this.settingTypes.number) {
        return {
          precision: 0,
          useThousandSeparator: false,
        }
      }
      if (this.settingType === this.settingTypes.boolean) {
        return {
          trueValue: '+',
          falseValue: '-',
        }
      }
      return {}
    },
    settingValue: {
      get() {
        let result = this.$_.cloneDeep(this.value)
        if (!result || (Array.isArray(result) && !result.length)) {
          result = this.$_defaultSettingValue(this.setting)
        } else {
          const { settingType } = this.setting
          if (settingType === this.settingTypes.number) {
            result = result ? +result : 0
          } else if (settingType === this.settingTypes.multipleSelectList) {
            if (!Array.isArray(result)) {
              result = result?.split(',')
            }
          } else if (settingType === this.settingTypes.inputList || settingType === this.settingTypes.emailList) {
            if (!Array.isArray(result)) {
              result = result ? result.split(',') : ['']
            }
          }
        }
        return result
      },
      set(v) {
        if (this.loading) { return }
        const { settingType } = this.setting
        let value = v
        if (settingType === this.settingTypes.form) {
          value = JSON.stringify(value || {})
        /*} else if (settingType === this.settingTypes.formList) {
          value = JSON.stringify(value || [{}])*/
        } else if (settingType === this.settingTypes.number) {
          value = value.toString()
        } else if (settingType === this.settingTypes.inputList || settingType === this.settingTypes.multipleSelectList || settingType === this.settingTypes.emailList) {
          value = value?.join(',').trim()
        }
        this.$emit('input', value)
      },
    },
    settingType() {
      return this.setting.settingType
    },
    componentType() {
      if (this.loading) {
        return 'div'
      }
      switch (this.settingType) {
      case this.settingTypes.number:
        return 'sInputNumber'
      case this.settingTypes.boolean:
      case this.settingTypes.forceBpm:
        return 'sSwitch'
      case this.settingTypes.timeSpan:
        return 'TimeSpan'
      case this.settingTypes.string:
      default:
        return 'sInput'
      }
    },
  },
  components: {
    TimeSpan,
    SettingsList,
    SettingsFormio,
    SettingHtmlView,
  },
  props: {
    value: {
      type: [Number, String, Array, Object, Boolean],
      default: null,
    },
    setting: {
      type: Object,
      default: () => ({}),
    },
    prop: {
      type: String,
      default: null,
    },
    organizationId: {
      type: Number,
      default: 0,
    },
    hideLabel: {
      type: Boolean
    },
    loading: {
      type: Boolean
    },
    showMessage: {
      type: Boolean,
      default: true
    },
    form: {
      type: Object,
      default: () => ({}),
    },
    /*formData: {
      type: Object,
      default: () => ({}),
    },*/
  },
}
</script>
